import React, { useState, useEffect } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

//i18n
import { withTranslation } from "react-i18next";
// Redux
import { Link } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import { createSelector } from 'reselect';

// users
import defaultImg from "../../../assets/images/defaultuserimgdark.png"
import { useSelector } from "react-redux";

const ProfileMenu = (props: any) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);

  const [username, setUsername] = useState("Admin");
  const [userrole, setUserrole] = useState("--");

  const selectProfileProperties = createSelector(
    (state: any) => state.Profile,
    (profile) => ({
      user: profile.user,
    })
  );

  const { user } = useSelector(selectProfileProperties);


  useEffect(() => {
    const updateUsername = () => {
      if (localStorage.getItem("authUser")) {
        const obj = JSON.parse(localStorage.getItem('userdata') || '{}')?.get_full_name || "admin";
        setUsername(obj);
      }
    };

    updateUsername();
    window.addEventListener("refreshProfile", updateUsername);
    return () => window.removeEventListener("refreshProfile", updateUsername);
  }, [user]);

  const iroles = {"adm":"Admin", "cst":"Customer", "exp":"Expert", "emp":"Employee", "prt":"Partner"}
  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <div className="d-flex align-items-center">
            <img
              className="rounded-circle header-profile-user"
              src={(JSON.parse(localStorage.getItem('userdata') || '{}')?.profile_pic ? JSON.parse(localStorage.getItem('userdata') || '{}')?.profile_pic : "") || defaultImg}
              alt="Header Avatar"
            />
            <div className="text-start">
                <span className="d-none d-xl-block ms-2 me-1 text-capitalize">{username}</span>
                <span className="d-none d-xl-inline-block ms-2 font-size-10">{(localStorage.getItem('userole_') ? ( 
                  iroles[localStorage.getItem('userole_') || ""] ) : "--")}</span>
                <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {/* <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/profile"}>  */}
          {(["cst", "adm", "exp", "prt"].includes(localStorage.getItem('userole_')||"")) ? 
          (<DropdownItem tag="a" href={`${process.env.PUBLIC_URL}/${(localStorage.getItem('userole_') || "")[0] || ""}profile`}> 
            {" "}
            <i className="bx bx-user font-size-16 align-middle me-1" />
            {props.t("Profile")}{" "}
          </DropdownItem>) : null}
          {localStorage.getItem('userole_') === "exp" ? 
          (<>
            <DropdownItem tag="a" href={`${process.env.PUBLIC_URL}/epayouts`}> 
              {" "}
              <i className="bx bx-money font-size-16 align-middle me-1" />
              {props.t("Payouts")}{" "}
            </DropdownItem>
            <div className="dropdown-divider" />
          </>) : null}
          {localStorage.getItem('userole_') === "prt" ? 
          (<>
            <DropdownItem tag="a" href={`${process.env.PUBLIC_URL}/ppayouts`}> 
              {" "}
              <i className="bx bx-money font-size-16 align-middle me-1" />
              {props.t("Payouts")}{" "}
            </DropdownItem>
            <DropdownItem tag="a" href={`${process.env.PUBLIC_URL}/custompricing`}> 
              {" "}
              <i className="bx bx-dollar font-size-16 align-middle me-1" />
              {props.t("Custom Pricing")}{" "}
            </DropdownItem>
            <div className="dropdown-divider" />
          </>) : null}
          {/* <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/crypto-wallet"}>
            <i className="bx bx-wallet font-size-16 align-middle me-1" />
            {props.t("My Wallet")}
          </DropdownItem> */}
          {/* <DropdownItem tag="a" href="#">
            <span className="badge bg-success float-end">11</span>
            <i className="bx bx-wrench font-size-16 align-middle me-1" />
            {props.t("Settings")}
          </DropdownItem> */}
          {/* <DropdownItem tag="a" href={process.env.PUBLIC_URL + "/auth-lock-screen"}>
            <i className="bx bx-lock-open font-size-16 align-middle me-1" />
            {props.t("Lock screen")}
          </DropdownItem> */}
          <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withRouter(withTranslation()(ProfileMenu));